import type { CinematicOverrides } from '../../../renderer/src/cinematic-sequence';
import { resolveCameraPlatform } from '../domain/camera-platform';
import { resolveCameraDistance } from '../domain/camera-distance';
import { cameraGimbalLabel } from './camera-gimbal-display';
import { resolveMapStyle } from '../domain/map-style';

/** Describes the output properties stored in one camera-settings key. */
export function sceneKeyframeSummary(value: CinematicOverrides): string {
  const items: string[] = [];
  if (value.cameraStyle !== undefined) items.push(`Camera Platform: ${resolveCameraPlatform(value.cameraStyle).label}`);
  if (value.cameraDistance !== undefined) items.push(`Lens: ${resolveCameraDistance(value.cameraDistance).label}`);
  if (value.cameraGimbal !== undefined) items.push(`Gimbal: ${cameraGimbalLabel(value.cameraGimbal)}`);
  if (value.cameraAngle !== undefined) items.push(`Angle: ${value.cameraAngle === null ? 'Automatic' : value.cameraAngle + '°'}`);
  if (value.cameraZoom !== undefined) items.push(`Map zoom: ${value.cameraZoom === null ? 'Auto' : value.cameraZoom}`);
  if (value.depthOfField !== undefined) {
    const focus = value.depthOfField;
    items.push(`DOF: ${focus.enabled ? 'On' : 'Off'}, blur ${focus.blur}, range ${Math.round(focus.width * 100)}%, ${focus.method === 'depth' ? 'Scene depth' : 'Tilt-shift'}, ${focus.focus === 'rider' ? 'Trace position' : 'Map center'}, overhead fade ${focus.fadeTopDown ? 'On' : 'Off'}`);
  }
  if (value.mapStyle !== undefined) items.push(`Map style: ${resolveMapStyle(value.mapStyle).label}`);
  if (value.presentationAppearance !== undefined) {
    if (value.presentationAppearance.plateTransparency !== undefined) items.push(`Plate transparency: ${value.presentationAppearance.plateTransparency}%`);
    if (value.presentationAppearance.textColor !== undefined) items.push(`Text color: ${value.presentationAppearance.textColor}`);
  }
  return items.join(' · ') || 'No property overrides';
}
